import { gql } from '@apollo/client';

import { AccountingQreFragment } from './AccountingQre.graphql';
import { PayrollQreFragment } from './PayrollQre.graphql';
import { RdExpenseFragment } from './RdExpense.graphql';

/**
 * This is a fragment used to encapsulate the fields used when querying for an rdExpense plus its relations.
 */
export const GetRdExpenseFragment = gql`
  fragment GetRdExpense on RdExpense {
    ...RdExpense
    accountingQre {
      ...AccountingQre
    }
    payrollQre {
      ...PayrollQre
    }
  }
  ${RdExpenseFragment}
  ${AccountingQreFragment}
  ${PayrollQreFragment}
`;
